import type { PageTemplateProps } from "./pageTemplateTypes";

export function BodyOnlyPageTemplate({ body }: PageTemplateProps) {
  return <>{body}</>;
}
